module.exports = __webpack_public_path__ + "static/media/bandages.41598dd0.png";